export const auth = {
  login: "accounts/login/",
  login_google: "accounts/login/google/",
  logout: "accounts/logout/",
  register: "accounts/register/user/",
  otp: "accounts/otp/user/",
  resend_otp: "accounts/resend/otp/user/",
  forget_password: "accounts/forget/password/user/",
  confrim_forget_password: "accounts/confirm/forget/password/user/",
  get_user_info: "accounts/user/site/",
  update_user_info: "accounts/user/site/",
  set_saved_basket_data: (currency_id: number) =>
    `products/basket/auth/?currency_id=${currency_id}`,
};
